var _rect, _g, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRustoreBadgeRu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 56,
    viewBox: "0 0 186 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 185,
    height: 55,
    rx: 11.5,
    fill: "#111111",
    stroke: "#A6A6A6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16 12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.345 32C8.109 32 4.473 32 2.218 29.749C-0.033 27.498 -0.033 23.898 -0.033 16.625V15.345C-0.033 8.109 -0.033 4.473 2.218 2.218C4.469 -0.033 8.069 -0.033 15.345 -0.033H16.625C23.861 -0.033 27.498 -0.033 29.749 2.218C32 4.469 32 8.069 32 15.345V16.625C32 23.861 32 27.498 29.749 29.749C27.498 32 23.898 32 16.625 32H15.345Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.626 5.855C17.789 5.847 17.062 6.52 17.062 7.4V9.28L13.135 8.302C13.013 8.271 12.891 8.256 12.771 8.255C11.935 8.247 11.207 8.92 11.207 9.8V11.673L7.316 10.702C6.338 10.458 5.389 11.196 5.389 12.2V22.636C5.389 23.524 5.993 24.295 6.855 24.509L13.071 26.058C14.049 26.302 14.998 25.564 14.998 24.56V14.124C14.998 13.488 14.686 12.913 14.193 12.56C14.185 12.534 14.187 12.506 14.203 12.483C14.23 12.443 14.279 12.424 14.325 12.438C15.143 12.685 15.922 13.522 16.002 14.576L16.272 22.538C16.279 22.805 16.457 23.032 16.708 23.116L18.89 23.658C19.869 23.902 20.818 23.164 20.818 22.16C20.844 18.717 20.836 15.215 20.837 11.76C20.837 11.291 20.679 10.931 20.501 10.669C20.472 10.625 20.441 10.582 20.409 10.541C20.37 10.491 20.328 10.444 20.284 10.398C20.219 10.33 20.149 10.265 20.074 10.207L20.072 10.205C20.041 10.174 20.032 10.126 20.058 10.089C20.085 10.049 20.134 10.03 20.18 10.044C20.998 10.291 21.78 11.128 21.856 12.182L22.126 20.145C22.133 20.409 22.309 20.635 22.559 20.715L24.745 21.26C25.724 21.504 26.673 20.766 26.673 19.762V9.326C26.673 8.438 26.069 7.667 25.207 7.453L18.99 5.904C18.868 5.874 18.746 5.858 18.626 5.855Z",
    fill: "white"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 23,
    fill: "white",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 11,
    fontWeight: 500
  }, "\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0432")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 40,
    fill: "white",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 21,
    fontWeight: 700
  }, "RuStore")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRustoreBadgeRu);
export default __webpack_public_path__ + "static/media/rustore-badge-ru.7606f1babccf30291da7ad3c162dab24.svg";
export { ForwardRef as ReactComponent };